import { Box, Switch, Typography } from "@mui/material";
import { useMeasurement } from "../hooks/useMeasurement";
import { FormattedMessage } from "react-intl";


export default function MeasurementPicker({ }) {
  const { type, setType } = useMeasurement();

  const handleChange = (event) => {
    if (event.target.checked) {
      setType('metric');
    } else {
      setType('imperial');
    }
  };

  return <Box style={{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  }} >
    <Typography><FormattedMessage id="MeasurementPicker.imperial" /></Typography>
    <Switch
      checked={type === 'metric'}
      onChange={handleChange}
      color="white"
    />
    <Typography><FormattedMessage id="MeasurementPicker.metric" /></Typography>
  </Box>
};